var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8968 2.89063C40.6362 8.59633 43.9071 21.1154 38.2014 30.8548C32.4957 40.5942 19.9766 43.8651 10.2372 38.1594C0.497833 32.4537 -2.77301 19.9346 2.93269 10.1952C8.63839 0.455777 21.1575 -2.81506 30.8968 2.89063ZM14.1037 31.5654C20.1961 35.1393 28.044 33.0911 31.6075 26.9883C35.1814 20.896 33.1332 13.048 27.0304 9.48458C20.938 5.91068 13.0901 7.95888 9.52663 14.0617C5.95274 20.154 8.00094 28.002 14.1037 31.5654Z",
    fill: "url(#paint0_linear_2443_6036)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2443_6036",
    x1: 44.6804,
    y1: -14.6131,
    x2: -46.8197,
    y2: 118.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D6D8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C3C5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#A3A6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7F83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRounded);
export default __webpack_public_path__ + "static/media/rounded.38f80af0814f5b27da8ca569c704b732.svg";
export { ForwardRef as ReactComponent };